import { BeautyType } from "./v1";

export type BeautyTypeV1Type = keyof typeof BeautyType;

export type BeautyTypeType = BeautyTypeV1Type;
